import { LazyQueryResultTuple, OperationVariables } from '@apollo/client';
import { useApolloLazyQuery, useCookie } from '@netfront/common-library';

import { IUseHowlerLazyQueryInputVariables } from './useHowlerLazyQuery.interfaces';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useHowlerLazyQuery = <TData = any, TVariables extends OperationVariables = OperationVariables>({
  authTokensCookieOptionalAttributes,
  customBuildGuid,
  options,
  product,
  projectId,
  query,
  requestCredentials,
  tokens,
}: IUseHowlerLazyQueryInputVariables<TData, TVariables>): LazyQueryResultTuple<TData, TVariables> => {
  const { getImpersonatedUserTemporaryTokenCookie, getTemporaryTokenCookie } =
    useCookie();

  const temporaryToken = getImpersonatedUserTemporaryTokenCookie() ?? getTemporaryTokenCookie();

  return useApolloLazyQuery<TData, TVariables>({
    apiName: 'howler',
    authTokensCookieOptionalAttributes,
    customBuildGuid,
    isPublic: false,
    options,
    projectId,
    product,
    query,
    requestCredentials,
    tokens:
      tokens ??
      (temporaryToken
        ? {
            accessToken: temporaryToken,
            refreshToken: '',
          }
        : undefined),
  });
};

export { useHowlerLazyQuery };
